<app-loading-animation *ngIf="isLoading"></app-loading-animation>
<div class="table-container">
  <div (scroll)="onTableScroll()" class="table-wrapper" >
    <table class="table table-bordered">
      <thead>
        <tr>
          <th class="column-1">
            <div class="th-content">
              <app-filter
                  [key]="'tradeName'"
                  (selectedOptionsChange)="applyFilters($event)"
                  [reset]="resetFilters"
              >
                Торгова назва
              </app-filter>
            </div>
          </th>
          <th class="column-2">
            <div class="th-content">
              <app-filter
                  [key]="'series'"
                  (selectedOptionsChange)="applyFilters($event)"
                  [reset]="resetFilters"
              >
                Серія/Каталожний номер
              </app-filter>
            </div>
          </th>
          <th class="column-3">
            <div class="th-content"><p>Розпорядчий документ</p></div>
          </th>
          <th class="column-4">
            <div class="th-content"><p>Номер документа</p></div>
          </th>
          <th class="column-5">
            <div class="th-content">
              <app-filter
                  [key]="'documentStatus'"
                  (selectedOptionsChange)="applyFilters($event)"
                  [reset]="resetFilters"
                >
                  Статус
                </app-filter>
            </div>
          </th>
          <th class="column-6">
            <div class="th-content"><p>Тип</p></div>
          </th>
          <th class="column-7">
            <div class="th-content"><p>Організація-ініціатор</p></div>
          </th>
          <th class="column-8">
            <div class="th-content"><p>Вплив</p></div>
          </th>
          <th class="column-9">
            <div class="th-content"><p>Всього у карантині</p></div>
          </th>
        </tr>
      </thead>
      <tbody>
      <ng-container *ngIf="!errorCode">
        <tr
            *ngFor=" let document of documents"
            (click)="onRowClick($event, document)"
        >
          <td class="column-1">{{ document.quarantineScope | groupBy:'tradeName' }}</td>
          <td class="column-2">
            <app-no-wrap-string-wrapper text="{{ document.quarantineScope | groupBy:'series' }}" />
          </td>
          <td class="column-3">{{ documentTypes[document.documentType] || document.documentType }}</td>
          <td class="column-4">{{ document.documentNumber }}</td>
          <td class="column-5">
            <div [documentStatusHighlight]="document.documentStatus">
              {{ statusTypes[document.documentStatus] || document.documentStatus }}
            </div>
          </td>
          <td class="column-6 text-nowrap">
            {{ placementTypes[document.transactionType] || document.transactionType }}
            <span class="removed-label" *ngIf="document.quarantineStatus ==='REMOVED'">
              <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 4.5L3.5 7L9.5 1" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>&nbsp;Знято
            </span>
          </td>
          <td class="column-7">{{ document.organizationName }}</td>
          <td class="column-8">{{ organisationTypes[document.quarantineOrganization] || document.quarantineOrganization }}</td>
          <td class="column-9">{{ document.totalAmount !== null ? document.totalAmount : '-' }}</td>
        </tr>
      </ng-container>
      <ng-container *ngIf="!errorCode && documents.length === 0 && !isLoading">
        <tr>
          <td [attr.colspan]="8">
            <div class="error-cell-content">
              <app-error
                  [errorCode]="404"
              />
            </div>
          </td>
        </tr>
      </ng-container>
      <ng-container *ngIf="errorCode">
        <tr>
          <td [attr.colspan]="8">
            <div class="error-cell-content">
              <app-error [errorCode]="errorCode"></app-error>
            </div>
          </td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>
  <div class="table-footer">
    <div class="left">
      <strong>Застосовані фільтри</strong> <span>{{ filterCount }}</span>
      <div (click)="onResetFilters()" class="icon-container">
        <med-icon-reset class="icon" size="16"></med-icon-reset>
      </div>
    </div>
    <div class="right">
      <med-pagination
          *ngIf="documents.length > 0"
          (pageChange)="onPageChange($event)"
          [page]="pagination.page"
          [perPage]="pagination.perPage"
          [total]="pagination.totalElements"
      ></med-pagination>
    </div>
  </div>
</div>